import React from 'react';
import Modal from "../../Common/Modals/Modal";

const FormSubmitModal = (props) => {

    return (
        <Modal id="FromSubmitModal"
               title={props.title}
               onClose={props.onClose}
               show={props.show}>
            <p>{props.message}</p>
        </Modal>
    );
}

export default FormSubmitModal;